import src from "IMAGE";
export default { src, width: 274, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AMtlWdyVPS5tgh8iQ4YgI0aBHiFCUxQWKi4LDBgsCgsXAGFUYpJGND5GRitGP0IrRztGK0ZAQic/OUcUGCk+DxAgVVcPw6qkzNEAAAAASUVORK5CYII="};
